import styled from 'styled-components';

import colors from '~/styles/colors';

const Content = styled.div`
  margin-top: 20px;
  padding: 30px;
  background: ${colors.grey400};
  border-radius: 4px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);
`;

export default Content;
